import { useEffect, useState } from 'react';
import financasApi from '@/lib/financasApi';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Settings, Save, Building2 } from 'lucide-react';
import { toast } from 'sonner';

export default function FinancasConfiguracoes() {
  const [form, setForm] = useState({ nome: '', cnpj: '', telefone: '', limite_mei_anual: 81000 });

  useEffect(() => {
    financasApi.get('/financas/empresa').then(({ data }) => {
      setForm({
        nome: data.nome || '',
        cnpj: data.cnpj || '',
        telefone: data.telefone || '',
        limite_mei_anual: data.limite_mei_anual || 81000,
      });
    }).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await financasApi.put('/financas/empresa', {
        nome: form.nome,
        cnpj: form.cnpj || null,
        telefone: form.telefone || null,
        limite_mei_anual: Number(form.limite_mei_anual),
      });
      toast.success('Configurações salvas');
      // atualiza localStorage para refletir nome
      const empresa = JSON.parse(localStorage.getItem('financas_empresa') || '{}');
      empresa.nome = form.nome;
      empresa.limite_mei_anual = Number(form.limite_mei_anual);
      localStorage.setItem('financas_empresa', JSON.stringify(empresa));
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao salvar');
    }
  };

  return (
    <div className="p-4 md:p-8 max-w-3xl mx-auto" data-testid="financas-config-page">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-white flex items-center gap-3"><Settings className="w-6 h-6 md:w-7 md:h-7 text-emerald-400" /> Configurações</h1>
        <p className="text-slate-400 text-xs md:text-sm mt-1">Dados da empresa e limites</p>
      </div>

      <form onSubmit={submit} className="bg-slate-900 border border-white/10 rounded-xl p-6 space-y-4">
        <div className="flex items-center gap-2 text-emerald-300 mb-2">
          <Building2 className="w-5 h-5" />
          <h3 className="font-semibold">Dados da Empresa</h3>
        </div>

        <div>
          <Label className="text-slate-400 text-xs">Nome da Empresa *</Label>
          <Input data-testid="financas-config-nome" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} className="bg-slate-950 border-white/10 text-white" required />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-slate-400 text-xs">CNPJ</Label>
            <Input value={form.cnpj} onChange={(e) => setForm({ ...form, cnpj: e.target.value })} className="bg-slate-950 border-white/10 text-white" placeholder="00.000.000/0000-00" />
          </div>
          <div>
            <Label className="text-slate-400 text-xs">Telefone</Label>
            <Input value={form.telefone} onChange={(e) => setForm({ ...form, telefone: e.target.value })} className="bg-slate-950 border-white/10 text-white" />
          </div>
        </div>

        <div className="border-t border-white/5 pt-4">
          <Label className="text-slate-400 text-xs">Limite Anual MEI/ME (R$)</Label>
          <Input
            data-testid="financas-config-limite"
            type="number"
            min="0"
            step="1000"
            value={form.limite_mei_anual}
            onChange={(e) => setForm({ ...form, limite_mei_anual: e.target.value })}
            className="bg-slate-950 border-white/10 text-white"
          />
          <p className="text-slate-500 text-xs mt-1">Padrão MEI 2026: R$ 81.000. ME pode ter limite maior.</p>
        </div>

        <div className="flex justify-end pt-4">
          <Button type="submit" data-testid="financas-config-salvar" className="bg-emerald-600 hover:bg-emerald-500 text-white">
            <Save className="w-4 h-4 mr-2" /> Salvar
          </Button>
        </div>
      </form>
    </div>
  );
}
